
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_1n452_149",
  "drawer-closed": "awsui_drawer-closed_1r9lg_1n452_189",
  "refresh": "awsui_refresh_1r9lg_1n452_189",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_1n452_194",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_1n452_210",
  "position-bottom": "awsui_position-bottom_1r9lg_1n452_217",
  "with-toolbar": "awsui_with-toolbar_1r9lg_1n452_234",
  "position-side": "awsui_position-side_1r9lg_1n452_249",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_1n452_258",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_1n452_269",
  "open-button-side": "awsui_open-button-side_1r9lg_1n452_280",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_1n452_289",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_1n452_299",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_1n452_303",
  "content-bottom": "awsui_content-bottom_1r9lg_1n452_315",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_1n452_334",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_1n452_339",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_1n452_343",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_1n452_347",
  "content-side": "awsui_content-side_1r9lg_1n452_352",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_1n452_364",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_1n452_373",
  "header": "awsui_header_1r9lg_1n452_384",
  "header-text": "awsui_header-text_1r9lg_1n452_397",
  "header-actions": "awsui_header-actions_1r9lg_1n452_410",
  "divider": "awsui_divider_1r9lg_1n452_418"
};
  